/* She & Me — global.js (vanilla, no dependencies) */
(function () {
  'use strict';
  var d = document;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };

  /* ---------- drawers (menu / search / overlay) ---------- */
  function setOpen(el, open) { if (el) el.setAttribute('data-open', open ? 'true' : 'false'); }
  var overlay = $('[data-overlay]');
  var menu = $('[data-menu-drawer]');
  var search = $('[data-search-modal]');

  function closeAll() {
    setOpen(overlay, false); setOpen(menu, false); setOpen(search, false);
    d.body.style.overflow = '';
  }
  function openDrawer(el, focusSel) {
    setOpen(overlay, true); setOpen(el, true); d.body.style.overflow = 'hidden';
    var f = focusSel && $(focusSel, el); if (f) setTimeout(function () { f.focus(); }, 60);
  }

  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(menu); }); });
  $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(search, 'input[type=search],input[name=q]'); }); });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
  if (overlay) overlay.addEventListener('click', closeAll);
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- desktop megamenu keyboard support ---------- */
  $$('.nav__item > .nav__link').forEach(function (link) {
    var item = link.parentNode;
    var panel = item.querySelector('.mega');
    if (!panel) return;
    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');
    if (link.tagName === 'BUTTON') {
      link.addEventListener('click', function () {
        var open = panel.getAttribute('data-open') === 'true';
        $$('.mega').forEach(function (p) { p.setAttribute('data-open', 'false'); });
        $$('.nav__item > .nav__link[aria-expanded]').forEach(function (l) { l.setAttribute('aria-expanded', 'false'); });
        panel.setAttribute('data-open', open ? 'false' : 'true');
        link.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    }
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) { panel.setAttribute('data-open', 'false'); link.setAttribute('aria-expanded', 'false'); }
    });
  });

  /* ---------- lazy images (strakker dan native lazy) ---------- */
  function loadImg(im) { if (im.hasAttribute('data-bg')) { im.style.backgroundImage = 'url(' + im.getAttribute('data-bg') + ')'; im.removeAttribute('data-bg'); return; } im.srcset = im.getAttribute('data-srcset'); im.removeAttribute('data-srcset'); im.classList.remove('js-lazy'); }
  var lio = 'IntersectionObserver' in window && new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { loadImg(e.target); lio.unobserve(e.target); } }); }, { rootMargin: '250px 300px' });
  function observeLazy(root) { $$('img.js-lazy, [data-bg]', root).forEach(function (im) { if (lio) lio.observe(im); else loadImg(im); }); }
  observeLazy(d);
  if (window.matchMedia('(hover:hover)').matches) {
    d.addEventListener('pointerover', function (e) {
      var card = e.target.closest && e.target.closest('[data-product-card]');
      var im = card && card.querySelector('img[data-hover-srcset]');
      if (im) { im.srcset = im.getAttribute('data-hover-srcset'); im.removeAttribute('data-hover-srcset'); }
    });
  }

  /* ---------- kleurbolletjes op productkaart: foto + link wisselen ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.card-sw');
    if (!b) return;
    e.preventDefault();
    var card = b.closest('[data-product-card]'), src = b.getAttribute('data-img');
    var im = card && card.querySelector('.card__img-1');
    if (im && src) {
      im.removeAttribute('data-srcset'); im.classList.remove('js-lazy');
      im.srcset = [300, 360, 400, 500, 700].map(function (w) { return src.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(',');
      card.classList.add('is-swatched');
    }
    $$('.card__media, .card__title a, .card__link a', card).forEach(function (a) { a.href = b.getAttribute('data-url'); });
    $$('.card-sw', card).forEach(function (x) { x.classList.toggle('is-active', x === b); });
  });

  /* ---------- cart count refresh ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.setAttribute('data-count', count); el.querySelector('[data-count-text]') && (el.querySelector('[data-count-text]').textContent = count); });
  }
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCartCount(c.item_count); })
      .catch(function () {});
  }

  /* ---------- add to cart (product form) ---------- */
  function btnLabel(btn, name, fallback) { return (btn && btn.getAttribute('data-text-' + name)) || fallback; }
  function btnTextEl(btn) { return btn && btn.querySelector('[data-btn-text]'); }

  $$('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // native fallback
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart]');
      var tx = btnTextEl(btn);
      var originalText = tx ? tx.textContent : '';
      if (btn) { btn.setAttribute('disabled', 'true'); if (tx) tx.textContent = btnLabel(btn, 'adding', 'Toevoegen…'); }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw res.body;
          refreshCart();
          if (btn) { if (tx) tx.textContent = btnLabel(btn, 'added', 'Toegevoegd ✓'); setTimeout(function () { if (tx) tx.textContent = originalText; btn.removeAttribute('disabled'); }, 1800); }
          var note = form.querySelector('[data-cart-note]'); if (note) { note.hidden = false; }
        })
        .catch(function (err) {
          if (btn) { if (tx) tx.textContent = originalText; btn.removeAttribute('disabled'); }
          var msg = form.querySelector('[data-add-error]');
          if (msg) { msg.textContent = (err && err.description) || btnLabel(btn, 'error', 'Kon niet toevoegen.'); msg.hidden = false; }
        });
    });
  });

  /* sticky add button triggers the real add-to-cart (keeps one product form) */
  $$('[data-sticky-add]').forEach(function (sticky) {
    sticky.addEventListener('click', function () {
      var real = d.querySelector('[data-add-to-cart]');
      if (real && !real.hasAttribute('disabled')) real.click();
    });
  });

  /* ---------- productgalerij: thumbnails, swipe, kleurfilter; foto's laden pas bij hover/swipe ---------- */
  var gallery = (function () {
    var g = $('[data-gallery]');
    if (!g) return null;
    var track = $('[data-pg-track]', g);
    var slides = $$('.pg-slide', track);
    var thumbs = $$('.pg-thumb', g);
    var counter = $('[data-pg-counter]', g);
    var desk = window.matchMedia('(min-width:990px)');
    var vis = [], cur = 0, color = null;
    function byId(list, id) { return list.filter(function (el) { return el.getAttribute('data-media-id') === id; })[0]; }
    function load(sl) { var im = sl && sl.querySelector('img[data-srcset]'); if (im) loadImg(im); }
    function ord(el) { return parseInt(el.style.order || '0', 10); }
    function collect() {
      vis = slides.map(function (s, i) { return { s: s, i: i }; }).filter(function (o) { return !o.s.hidden; })
        .sort(function (a, b) { return (ord(a.s) - ord(b.s)) || (a.i - b.i); }).map(function (o) { return o.s; });
      track.setAttribute('data-count', Math.min(3, vis.length));
    }
    function paint() {
      slides.forEach(function (s) { s.classList.remove('pg-slide--p1', 'pg-slide--p2', 'pg-slide--p3'); });
      for (var k = 0; k < Math.min(3, vis.length); k++) {
        var s = vis[(cur + k) % vis.length];
        s.classList.add('pg-slide--p' + (k + 1));
        if (desk.matches || k === 0) load(s);
      }
      var id = vis[cur] && vis[cur].getAttribute('data-media-id');
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-media-id') === id ? 'true' : 'false'); });
      if (counter) counter.textContent = (cur + 1) + ' / ' + vis.length;
    }
    function go(i, smooth) {
      if (!vis.length) return;
      cur = (i + vis.length) % vis.length;
      load(vis[cur]); load(vis[(cur + 1) % vis.length]);
      if (!desk.matches) { try { track.scrollTo({ left: cur * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' }); } catch (e) { track.scrollLeft = cur * track.clientWidth; } }
      paint();
    }
    var tick;
    track.addEventListener('scroll', function () {
      if (desk.matches) return;
      load(vis[cur + 1]);
      clearTimeout(tick);
      tick = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== cur) { cur = i; load(vis[cur]); load(vis[cur + 1]); paint(); }
      }, 90);
    }, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener('pointerenter', function () { load(byId(slides, t.getAttribute('data-media-id'))); });
      t.addEventListener('click', function () { go(vis.indexOf(byId(slides, t.getAttribute('data-media-id'))), true); });
    });
    var prev = $('[data-pg-prev]', g), next = $('[data-pg-next]', g);
    if (prev) prev.addEventListener('click', function () { go(cur - 1, true); });
    if (next) next.addEventListener('click', function () { go(cur + 1, true); });
    if (desk.addEventListener) desk.addEventListener('change', function () { go(cur); });
    collect();
    paint();
    /* thumbnails + sticky-foto pas na de hoofdfoto (geen concurrentie met LCP) */
    var leadImg = vis[0] && vis[0].querySelector('img');
    function loadThumbs() {
      setTimeout(function () {
        thumbs.forEach(function (t) { if (!t.hidden) load(t); });
        load(d.querySelector('.sticky-buy__img'));
      }, 300);
    }
    if (!leadImg || leadImg.complete) loadThumbs(); else { leadImg.addEventListener('load', loadThumbs); leadImg.addEventListener('error', loadThumbs); }
    return {
      filter: function (c, leadId) {
        if (c === color) return;
        color = c;
        var lead = String(leadId || '');
        var any = slides.some(function (s) { var mc = s.getAttribute('data-media-color'); return mc === 'all' || mc === c; });
        slides.concat(thumbs).forEach(function (el) {
          var mc = el.getAttribute('data-media-color');
          el.hidden = !(!c || !any || mc === 'all' || mc === c);
          el.style.order = (lead && el.getAttribute('data-media-id') === lead) ? '-1' : '';
          if (!el.hidden && el.classList.contains('pg-thumb')) load(el);
        });
        collect();
        go(0);
        var si = d.querySelector('.sticky-buy__img img'), li = vis[0] && vis[0].querySelector('img');
        if (si && li) { si.removeAttribute('data-srcset'); si.classList.remove('js-lazy'); si.srcset = li.getAttribute('srcset') || li.getAttribute('data-srcset'); }
      },
      init: function (c) { color = c; }
    };
  })();
  function selectedVariantColor() {
    var fs = d.querySelector('[data-color-option]');
    var r = fs && fs.querySelector('input[type=radio]:checked');
    return r ? r.value.trim().toLowerCase() : null;
  }

  /* ---------- variant selection ---------- */
  $$('[data-variant-selects]').forEach(function (root) {
    var jsonEl = $('[data-variant-json]', root) || d.querySelector('[data-variant-json]');
    var data = JSON.parse((jsonEl || {}).textContent || '[]');
    var priceEl = $('[data-price-target]', root) || null;
    var form = root.closest('form') || d.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var addBtn = form && form.querySelector('[data-add-to-cart]');

    function currentOptions() {
      return $$('input[type=radio]:checked, select', root).map(function (i) { return i.value; });
    }
    function findVariant(opts) {
      return data.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function markAvailability() {
      // for radio-based single-size selects, disable unavailable combos
      $$('fieldset[data-option-index]', root).forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        var chosen = currentOptions();
        $$('input[type=radio]', fs).forEach(function (input) {
          var test = chosen.slice(); test[idx] = input.value;
          var match = data.find(function (v) { return v.options.slice(0, idx + 1).every(function (o, i) { return o === test[i]; }); });
          var label = fs.querySelector('label[for="' + input.id + '"]');
          var avail = match && match.available;
          if (label) label.classList.toggle('is-unavailable', !avail);
        });
      });
    }
    var stickyBtn = d.querySelector('[data-sticky-add]');
    var reassure = d.querySelector('[data-reassure]');
    function setBtnState(btnEl, hasVariant, available) {
      if (!btnEl) return;
      var tx = btnEl.querySelector('[data-btn-text]');
      if (!hasVariant) { btnEl.setAttribute('disabled', 'true'); if (tx) tx.textContent = btnLabel(btnEl, 'choose', 'Kies eerst je maat'); return; }
      if (available) { btnEl.removeAttribute('disabled'); if (tx) tx.textContent = btnLabel(btnEl, 'default', 'In winkelmand'); }
      else { btnEl.setAttribute('disabled', 'true'); if (tx) tx.textContent = btnLabel(btnEl, 'soldout', 'Uitverkocht'); }
    }
    function update() {
      var v = findVariant(currentOptions());
      markAvailability();
      $$('fieldset[data-option-index]', root).forEach(function (fs) {
        var c = fs.querySelector('input:checked'), t = fs.querySelector('[data-option-value]');
        if (c && t) t.textContent = c.value;
      });
      if (gallery) gallery.filter(selectedVariantColor(), v && v.media);
      var avail = !!(v && v.available);
      setBtnState(addBtn, !!v, avail);
      setBtnState(stickyBtn, !!v, avail);
      if (reassure) reassure.hidden = !avail;
      var low = d.querySelector('[data-low-stock]'), notify = d.querySelector('[data-notify]');
      if (low) {
        var n = v && v.available ? v.low : 0, si = parseInt(low.getAttribute('data-size-index'), 10);
        low.hidden = !(n > 0);
        if (n > 0) low.querySelector('[data-low-text]').textContent = 'Nog maar ' + n + (n === 1 ? ' stuk' : ' stuks') + (si >= 0 ? ' in maat ' + v.options[si] : '');
      }
      if (notify) {
        notify.hidden = !v || avail;
        if (v && !avail) notify.href = 'https://wa.me/' + notify.getAttribute('data-wa') + '?text=' + encodeURIComponent('Hallo Joke, laat je me weten wanneer ' + notify.getAttribute('data-title') + ' (' + v.options.join(' / ') + ') terug is? Dankjewel!');
      }
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_html || priceEl.innerHTML;
      var stickyPrice = d.querySelector('[data-sticky-price]'); if (stickyPrice && v.price_html) stickyPrice.innerHTML = v.price_html;
      var url = new URL(window.location); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
    }
    $$('input[type=radio], select', root).forEach(function (i) { i.addEventListener('change', update); });
    markAvailability();
    if (gallery) gallery.init(selectedVariantColor());
  });

  /* ---------- cart quantity (cart page) ---------- */
  $$('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
        var val = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        input.value = val; input.form && input.form.requestSubmit ? input.form.requestSubmit() : (input.form && input.form.submit());
      });
    });
  });

  /* ---------- sticky mobile buy bar ---------- */
  var stickyBar = $('[data-sticky-buy]');
  var buyAnchor = $('[data-buy-anchor]');
  if (stickyBar && buyAnchor && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      stickyBar.setAttribute('data-visible', entries[0].isIntersecting ? 'false' : 'true');
    }, { threshold: 0 });
    io.observe(buyAnchor);
  }

  refreshCart();

  /* ---------- soft reveal on scroll ---------- */
  var animated = $$('[data-animate]');
  if (animated.length) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      animated.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var ro = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); } });
      }, { threshold: 0.12 });
      animated.forEach(function (el) { ro.observe(el); });
    }
  }

  /* ---------- lazy + consent-bewust third-party (Trustprofile) ---------- */
  (function () {
    var frames = $$('[data-tp-src]');
    if (!frames.length) return;
    function canLoad() {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
          return cp.analyticsProcessingAllowed() ||
                 (typeof cp.preferencesProcessingAllowed === 'function' && cp.preferencesProcessingAllowed());
        }
      } catch (e) {}
      return true; // geen consent-API/banner actief → reviews gewoon (lazy) tonen
    }
    function load(frame) {
      if (frame.getAttribute('src')) return;
      frame.setAttribute('src', frame.getAttribute('data-tp-src'));
      var ph = frame.parentNode.querySelector('[data-tp-placeholder]');
      if (ph) ph.hidden = true;
    }
    function activate(frame) {
      if (canLoad()) { load(frame); return; }
      var ph = frame.parentNode.querySelector('[data-tp-placeholder]');
      if (ph) {
        ph.hidden = false;
        var b = ph.querySelector('[data-tp-load]');
        if (b) b.addEventListener('click', function () { load(frame); });
      }
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents, obs) {
        ents.forEach(function (e) { if (e.isIntersecting) { activate(e.target); obs.unobserve(e.target); } });
      }, { rootMargin: '300px' });
      frames.forEach(function (f) { io.observe(f); });
    } else { frames.forEach(activate); }
    document.addEventListener('visitorConsentCollected', function () {
      frames.forEach(function (f) { if (canLoad()) load(f); });
    });
  })();

  /* ---------- micro-conversie events → Customer Events pixel ---------- */
  function pub(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {} }
  $$('[data-testid="pdp-whatsapp"], .wa-float, a[href*="wa.me"]').forEach(function (a) {
    a.addEventListener('click', function () { pub('whatsapp_click', {}); });
  });

  /* ---------- maattabel (size guide) modal ---------- */
  (function () {
    var modal = $('[data-size-guide]');
    if (!modal) return;
    function openSg() { setOpen(overlay, true); modal.setAttribute('data-open', 'true'); d.body.style.overflow = 'hidden'; pub('size_guide_open', {}); }
    function closeSg() { modal.setAttribute('data-open', 'false'); setOpen(overlay, false); d.body.style.overflow = ''; }
    $$('[data-size-guide-open]').forEach(function (b) { b.addEventListener('click', openSg); });
    $$('[data-size-guide-close]', modal).forEach(function (b) { b.addEventListener('click', closeSg); });
    if (overlay) overlay.addEventListener('click', closeSg);
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSg(); });
  })();

  /* ---------- productaanbevelingen (related / complementary) ---------- */
  $$('[data-reco]').forEach(function (box) {
    var pid = box.getAttribute('data-product-id');
    var intent = box.getAttribute('data-intent') || 'related';
    if (!pid) return;
    fetch('/recommendations/products?section_id=product-recommendations&product_id=' + pid + '&intent=' + intent + '&limit=4')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = d.createElement('div'); tmp.innerHTML = html;
        var sec = tmp.querySelector('[data-testid="product-recommendations"]');
        if (sec && sec.querySelector('.card')) { box.appendChild(sec); observeLazy(sec); }
      }).catch(function () {});
  });

  /* ---------- recent bekeken (localStorage, privacyvriendelijk) ---------- */
  (function () {
    var cur = $('[data-recently-viewed-current]');
    var grid = $('[data-recent-grid]');
    var KEY = 'sheandme_recent';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    var curUrl = null;
    if (cur) {
      try {
        var data = JSON.parse(cur.textContent);
        curUrl = data.url;
        list = list.filter(function (x) { return x.url !== data.url; });
        list.unshift(data);
        list = list.slice(0, 8);
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {}
    }
    if (grid) {
      var others = list.filter(function (x) { return x.url !== curUrl; }).slice(0, 4);
      if (others.length) {
        grid.innerHTML = others.map(function (p) {
          return '<article class="card"><a class="card__media" href="' + p.url + '"><span class="card__media-inner"><img class="card__img-1" src="' + p.image + '" alt="" loading="lazy"></span></a><div class="card__body"><h3 class="card__title"><a href="' + p.url + '">' + p.title + '</a></h3><div class="card__meta"><span class="price"><span class="price__regular">' + p.price + '</span></span></div><div class="card__link"><a class="btn-sheme-cart btn-sheme-cart--card" href="' + p.url + '"><span class="btn-sheme-cart__text">Bekijk details en opties</span><span class="btn-sheme-cart__leaf btn-sheme-cart__leaf--bg" aria-hidden="true"></span></a></div></div></article>';
        }).join('');
        var wrap = $('#recently-viewed'); if (wrap) wrap.hidden = false;
      }
    }
  })();

  /* ---------- galerij-zoom (lightbox) ---------- */
  (function () {
    var lb = $('[data-zoom-lightbox]');
    if (!lb) return;
    var zimg = $('[data-zoom-img]', lb);
    function openZoom(src) { if (!src) return; zimg.setAttribute('src', src); lb.setAttribute('data-open', 'true'); lb.setAttribute('aria-hidden', 'false'); d.body.style.overflow = 'hidden'; }
    function closeZoom() { lb.setAttribute('data-open', 'false'); lb.setAttribute('aria-hidden', 'true'); d.body.style.overflow = ''; }
    $$('.pg-slide').forEach(function (sl) {
      sl.addEventListener('click', function () { if (!sl.hidden) openZoom(sl.getAttribute('data-zoom')); });
    });
    $$('[data-zoom-close]', lb).forEach(function (b) { b.addEventListener('click', closeZoom); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeZoom(); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
  })();
})();
